export enum RenewalPreferences {
    RENEWAL_THIS_YEAR = "renewal_this_year",
    RENEWAL_EVERY_YEAR = "renewal_every_year",
    NO_RENEWAL = "no_renewal",
}

export enum MultiTabBroadcastEvents {
    REDIRECT_ALL_OTHER_TABS_EVENT = "REDIRECT_ALL_OTHER_TABS_EVENT",
    INSTANCE_CHECK_EVENT = "instanceCheck", // Event required for check to determine if second tab was opened with same tabId
    RETURN_OTHER_TABS_TO_LAST_PAGE = "RETURN_OTHER_TABS_TO_LAST_PAGE"
}

export enum StoragesKeys {
    UNIQUE_TAB_INSTANCE_ID = "uniquetabinstanceid", // Part of tab duplicate workaround - works together with INSTANCE_CHECK_EVENT
    TAB_ID = "tabId", // Unique id for each tab - generated at start and regenerated if duplicate tabId exist on the same browser
    BACK_REDIRECT = "backRedirect", // Last page before forced multiTab page for each tab
}

